import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"i-label-main d-flex align-center"},[_c(VIcon,{attrs:{"small":"","color":"blue"}},[_vm._v("mdi-circle")]),_c('span',{staticClass:"pa-1 label-text"},[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }